import { useEffect, useRef } from 'react';
import { useIsForegroundNow } from './useIsForegroundNow';

/**
 * 현재 화면이 포그라운드에 진입할 때 콜백을 실행하는 훅
 * - useIsForegroundNow가 false → true로 전환될 때 콜백 실행
 * - 네이티브 화면 복귀 시 focus된 화면에서만 콜백을 실행
 */
export const useOnForeground = (callback: () => void) => {
  const isForeground = useIsForegroundNow();
  const prevIsForeground = useRef(isForeground);

  useEffect(() => {
    if (!prevIsForeground.current && isForeground) {
      callback();
    }
    prevIsForeground.current = isForeground;
  }, [isForeground, callback]);
};
